import { useState } from 'react';
import { getSdkInfoByKey } from '@gonfalon/sdk-info/sdkInfo';
import { Alert, Heading, Text } from '@launchpad-ui/components';

import { useOnboardingStorage } from '../../hooks';

import styles from './SdkKeyCallout.module.css';

type SdkKeyCalloutProps = {
  hasSnippets?: boolean;
};

export const SdkKeyCallout = ({ hasSnippets = false }: SdkKeyCalloutProps) => {
  const [dismissed, setDismissed] = useState(false);
  const { sdk, selectedEnvironment } = useOnboardingStorage();
  const sdkInfo = getSdkInfoByKey(sdk);
  const environmentName = selectedEnvironment?.name || selectedEnvironment?.key;
  const { initKey } = sdkInfo;
  const firstInitKey = initKey[0];

  if (dismissed) {
    return null;
  }

  const calloutText = {
    mobile: {
      title: 'Mobile key',
      keyText: 'mobile key',
      secretText: 'Mobile keys do not need to be kept secret. However if you wish to reset a mobile key, you can.',
    },
    serverSide: {
      title: 'SDK key',
      keyText: 'SDK key (server-side)',
      secretText: 'SDK keys should be kept secret. If an SDK key is exposed, you can reset it.',
    },
    clientSide: {
      title: 'Client-side ID',
      keyText: 'client-side ID',
      secretText: 'Client-side IDs do not need to be kept secret and cannot be reset.',
    },
  }[firstInitKey];

  const environmentPhrase = environmentName ? (
    <>
      the <Text className={styles.boldText}>{environmentName}</Text> environment
    </>
  ) : (
    'your environment'
  );

  return (
    <Alert status="info" isDismissable onDismiss={() => setDismissed(true)}>
      <Heading>{calloutText?.title}</Heading>
      <Text>
        This SDK uses your <Text className={styles.boldText}>{calloutText?.keyText}</Text>.
        {hasSnippets && <> It's already included in the code snippet below for {environmentPhrase}.</>}{' '}
        {calloutText?.secretText}
      </Text>
    </Alert>
  );
};
